import PropTypes from 'prop-types';
import React from 'react';

export const UnderlyingPriceExitWrapper = ({
  softOrder,
  Component,
  ...rest
}) => {

  const details = {
    tacticName: 'UNDERLYING_PRICE_EXIT',
    category: 'Exit',
    type: 'Underlying Price Exit',
    domain: 'Underlying',
  };
  const { underlyingPriceExits } = softOrder; 

  return <Component details={details} underlyingPriceExits={underlyingPriceExits} {...rest} />;
};

UnderlyingPriceExitWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    underlyingPriceExits: PropTypes.any
  })
};
